import { AutenticacionService } from './autenticacion.service';
import { Http, ResponseContentType } from '@angular/http';
import { ConstantsService } from './constants.service';
import { Injectable } from '@angular/core';

@Injectable()
export class ArchivosCreditosService {

  private service_url : string = null;
  constructor(
      private constantsService: ConstantsService, 
      private http: Http, 
      private authService: AutenticacionService
      ) {
        this.service_url = this.constantsService.apiURL + '/archivosContratos';
  }

  public save( event : any, fileInfo : any) {
    let fileList: FileList = event.target.files;
    if(fileList.length > 0) {
        let file: File = fileList[0];
        let formData : FormData = new FormData();
        formData.append('id', fileInfo.idCreditos);
        formData.append('tipo', fileInfo.tipo);
        formData.append('descripcion', fileInfo.descripcion);
        formData.append('file', file, file.name);
        /** In Angular 5, including the header Content-Type can invalidate your request */
        //headers.append('Content-Type', 'multipart/form-data');
        return this.http.post(this.service_url , formData, this.authService.getAuthHeaders());
    }
  }

  public get(idCreditos: number, tipo: number) {
    const serviceUrl = this.service_url + '?idCreditos=' + idCreditos + '&tipo=' + tipo;
    return this.http.get(serviceUrl, this.authService.getAuthHeaders());
  }

  public delete(id : number) {
    let serviceUrl = this.service_url + '/'+ id;
    return this.http.delete(serviceUrl , this.authService.getAuthHeaders());
  }

  public getFile(id: number) {
    const options = this.authService.getAuthHeaders();
    let serviceUrl = this.service_url + '/'+ id + '?action=download';
    options.responseType = ResponseContentType.Blob;
    return this.http.get(serviceUrl, options);
  }

  public update(archivos : any) {
    return this.http.put(this.service_url, archivos, this.authService.getAuthHeaders());
  }
}



// WEBPACK FOOTER //
// ./src/app/services/archivos-creditos.service.ts